const TreeNode = require('../TreeNode');
const UseAbility = require('../UseAbility');
const AICalc = require('../AICalc');
const BattleCalc = require('../../BattleCalc');
const Q_which_ranged_attack = require('./Q_which_ranged_attack');

const Q_target_high_hp = function (actor, battleState) {
  const node = new TreeNode(actor, battleState);

  node.YES = 'yes';
  node.NO = 'no';

  node.voidSpike = BattleCalc.getEquippedAbility(actor, 'void_spike');
  node.arrowShot = BattleCalc.getEquippedAbility(actor, 'arrow_shot');
  node.multiShot = BattleCalc.getEquippedAbility(actor, 'multi_shot');
  node.razorShot = BattleCalc.getEquippedAbility(actor, 'razor_shot');
  node.infectMind = BattleCalc.getEquippedAbility(actor, 'infect_mind');
  node.fumigate = BattleCalc.getEquippedAbility(actor, 'fumigate');
  node.lightning = BattleCalc.getEquippedAbility(actor, 'lightning');
  node.molotov = BattleCalc.getEquippedAbility(actor, 'molotov_cocktail');
  node.DAMAGE_DICT = {
    void_spike: node.voidSpike ? node.voidSpike.damage : 0,
    arrow_shot: node.arrowShot ? node.arrowShot.damage : 0,
    razor_shot: node.razorShot ? node.razorShot.potency : 0,
    multi_shot: node.multiShot ? node.multiShot.damage : 0,
    infect_mind: node.infectMind ? node.infectMind.potency : 0,
    fumigate: node.fumigate ? node.fumigate.potency : 0,
    lightning: node.lightning ? node.lightning.damage : 0,
    molotov_cocktail: node.molotov ? node.molotov.damage : 0,
  };

  node.best_bleed_ability_handle = getBestBleedAbility();

  node.branches[node.NO] = new Q_which_ranged_attack(actor, battleState);

  if (node.razorShot || node.infectMind || node.fumigate) {
    node.branches[node.YES] = new UseAbility(
      actor,
      node.best_bleed_ability_handle
    );
  } else {
    node.branches[node.YES] = node.branches[node.NO];
  }

  function getBestBleedAbility() {
    let _top_potency_handle = null;
    let _top_potency = 0;
    for (const [key, value] of Object.entries(node.DAMAGE_DICT).filter(
      ([key]) =>
        ['razor_shot', 'infect_mind', 'fumigate'].includes(key) &&
        BattleCalc.getEquippedAbility(actor, key)
    )) {
      if (value > _top_potency) {
        _top_potency = value;
        _top_potency_handle = key;
      }
    }
    return _top_potency_handle;
  }

  node.query = function (target) {
    if (
      node.yesNoEvalFunction(target) &&
      !!(node.razorShot || node.infectMind || node.fumigate)
    ) {
      // for ranged bleeds, try to spread DoTs to non-bleeding targets before applying new stacks
      target = AICalc.getBestDoTTarget(actor, target, battleState);

      return node.branches[node.YES].query(target);
    } else {
      return node.branches[node.NO].query(target);
    }
  };

  node.yesNoEvalFunction = function (target) {
    const dot_potency = BattleCalc.getCombinedDoTPotency(target);
    if (dot_potency > target.hp * 0.333) return false;

    node.topDamageHandle = node.calculateTopDamage();

    return (
      node.best_bleed_ability_handle &&
      node.topDamageHandle &&
      (node.topDamageHandle === 'fumigate'
        ? BattleCalc.moreEnemiesThanAlliesInFumigateRange(actor, battleState)
        : true) &&
      target.hp > node.topDamage * 2.5
    );
  };

  node.calculateTopDamage = function () {
    let _top_damage_handle = null;
    node.topDamage = 0;
    for (const [key, value] of Object.entries(node.DAMAGE_DICT)) {
      if (
        BattleCalc.getEquippedAbility(actor, key) &&
        value > node.topDamage &&
        (key === 'fumigate' ? node.fumigate_ok : true)
      ) {
        node.topDamage = value;
        _top_damage_handle = key;
      }
    }
    return _top_damage_handle;
  };

  return node;
};
module.exports = Q_target_high_hp;
